define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/comm/PostRequest",
	"csi/state/rootStore",
	"csi/table/New",
	"./FormulatedMaterialSamplesForm"
], function(array,declare,lang,csi,PostRequest,{ routerStore },New,FormulatedMaterialSamplesForm) {

	return declare(New, {
		// Boolean: default New controller only adds one node - this controller may add many
		bUpdateParent: false,

		// Boolean: validation is handled explicitly
		bValidate: false,

		/**
		 * Add special controller for copy form
		 */
		onCreatePopupDefView: function(defView) {
			defView.classController = FormulatedMaterialSamplesForm;
		},

		/**
		 * use return value as parameter to success message
		 */
		getStringParameters: function() {
			var cntr = this.samples == null ? 0 : this.samples.length;
			return [cntr];
		},

		/**
		 * add new url to request
		 * @param{Array} urlsNew
		 */
		getReturnNodeRequest: function(urlsNew) {
			return this.inherited(arguments, [urlsNew.concat(this.samples)]);
		},

		/**
		 * get nodes resulting from action for postprocessing
		 */
		getNewNodes: function() {
			return this.m_cache.getNodes(this.samples);
		},

		/**
		 * @override
		 * initialize product and supplier on samples form (can be overridden)
		 */
		onCreatePopup: function(view) {
		    view.setProduct(routerStore.getBreadcrumbNode("FormulatedMaterial"));
		    view.setSupplier(this.getParent().Supplier, this.getParent().$Name);
		},

		/**
		 * create samples according to form and add to source
		 */
		toWriter: function() {
			this.samples = this.popupView.toWriterSamples(this);
		},

		/**
		 * disable Save & Go since action can create multiple samples
		 */
		_canNavigate: function() {
			return false;
		}
	});
});